import {useQuery, useQueryClient} from '@tanstack/react-query'
import {ApiUrls} from "../config/urls";
import {getStoreRouteCacheTime} from "../utils/helpers";
import Constants from "../config/constants";

const uniqId = 1;

const useRouteQuery = (slug, url, options) => {
    options.queryKey = [url, slug, uniqId];
    return useQuery(options);
}

// export function useRoute(language, type, slug, unlock, options = {}) {
//     const queryClient = useQueryClient();
//     const url = getRouteUrl(type, language);
//     options.enabled = Boolean(url && slug) && unlock === false;
//     options = {...queryClient.getDefaultOptions().queries, ...options, enabled: Boolean(url && slug && !unlock)}
//
//     return useRouteQuery(language, slug, url, options);
// }

export function hasAllSectorSaved(user, cliff) {
    if (!user?.customerRoutes
        || !Array.isArray(user.customerRoutes)
        || cliff?.enabledSectors.length === 0) {
        return false;
    }

    let hasAllSector = true;
    cliff.enabledSectors.forEach((sector) => {
        if (typeof (user.customerRoutes.find((el) => el.route.id === sector.id)) === "undefined") {
            hasAllSector = false;
            return false;
        }
    });

    return hasAllSector;
}

export function hasUserStoreRouteBySlug(user, slug) {
    if (!user?.customerRoutes || !Array.isArray(user.customerRoutes)) {
        return null;
    }

    return user.customerRoutes.find((r) => r.route.slug === slug);
}

export function useRouteMedias(url, route, slug, user = {}) {
    const queryClient = useQueryClient();

    let options = {
        ...queryClient.getDefaultOptions().queries,
        enabled: Boolean(url) && user?.id && Boolean(route) && route.hasOwnProperty('checksumMedias') && Boolean(route?.checksumMedias),
        queryKey: [url, route?.checksumMedias]
    };

    options = setStoreRouteCacheTime(options, slug, user);

    return useQuery(options);
}

function setStoreRouteCacheTime(options, slug, user) {
    const storeRoute = hasUserStoreRouteBySlug(user, slug);
    let cacheTime = null;
    if (storeRoute) {
        // if (typeof queryClient.getQueryData([url, slug]) !== "undefined"
        //     && !queryClient.getQueryCache().find([url, slug]).state.isInvalidated) {
        //     hasStoreData = true;
        // }

        cacheTime = getStoreRouteCacheTime(storeRoute?.endValidationDate);
        if (cacheTime === -1) {
            options.refetchOnWindowFocus = true;
            //options.cacheTime = Infinity;
            //options.networkMode ='offlineFirst';
        }
        if (cacheTime > 0) {
            options.refetchOnWindowFocus = false;
            options.cacheTime = cacheTime;
            options.staleTime = cacheTime;
            options.networkMode ='offlineFirst';
        }
    } else {
        options.staleTime = 0;
    }

    return options;
}

export function useRoute(url, slug, user = {}, forceStaleTime = null) {
    const queryClient = useQueryClient();
    let options = {...queryClient.getDefaultOptions().queries, staleTime: 0};
    options = setStoreRouteCacheTime(options, slug, user);

    if (forceStaleTime !== null) {
        options.staleTime = forceStaleTime;
    }

    if (!slug) {
        options.enabled = false;
    }

    //We need an error to fetch public infos
    //options.enabled = Boolean(url && slug && user?.email /*&& cacheTime !== -1*/);

    return useRouteQuery(slug, url, options);
}

export function getCliffUrl(type, language, slug)
{
    return ApiUrls.CLIFF.replace('{lng}', language).replace('{slug}', slug);
}

export function getRouteMediasUrl(type, language, slug, route)
{
    if (type === Constants.CLIFF) {
        return ApiUrls.SECTOR_ROUTE.replace('{lng}', language).replace('{slug}', slug) + '/medias';
    }

    if (type === Constants.MULTIPITCH && Boolean(route?.faceId)) {
        return ApiUrls.FACE_ROUTE_MEDIAS.replace('{lng}', language).replace('{id}', route.faceId);
    }

    return null;
}

export function getRouteUrl(type, language, slug)
{
    if (type === Constants.CLIFF) {
        return ApiUrls.SECTOR_ROUTE.replace('{lng}', language).replace('{slug}', slug);
    }

    if (type === Constants.MULTIPITCH) {
        return ApiUrls.MULTIPITCH_ROUTE.replace('{lng}', language).replace('{slug}', slug);
    }
}
